import React from 'react'
import {
    formatTicketDateTime,
    formatTicketRelativeTime,
    getEscalationHistoryKind,
    getEscalationHistoryTitle,
    stripEscalationNotesPrefix,
} from './utils'
import {
    Timeline,
    TimelineItem,
    TlTitle,
    TlMeta,
    TlBody,
} from './styles'

export const EscalationHistory = ({ events, hasEscalationPolicy = false }) => {
    const sweepEvents = (events || []).filter(item => {
        const kind = getEscalationHistoryKind(item)
        return kind === 'reminded' || kind === 'escalated' || kind === 'overdue'
    })
    const createdOnly =
        (events || []).length > 0 &&
        sweepEvents.length === 0 &&
        (events || []).every(item => getEscalationHistoryKind(item) === 'created')

    if (!events?.length) {
        return (
            <div style={{ color: '#64748b', fontSize: 13, lineHeight: 1.5 }}>
                No escalation events yet.
                {!hasEscalationPolicy && (
                    <div style={{ marginTop: 8 }}>
                        Link an Escalation policy on the auto-ticket rule to
                        enable reminders, escalation, and overdue notifications.
                    </div>
                )}
            </div>
        )
    }

    return (
        <>
            <Timeline>
                {events.map(item => {
                    const kind = getEscalationHistoryKind(item)
                    const when =
                        formatTicketRelativeTime(item.createdOn) ||
                        formatTicketDateTime(item.createdOn)
                    const actor =
                        item.actorFullName ||
                        item.actorEmail ||
                        (kind === 'created'
                            ? 'Auto-Ticket'
                            : 'Auto-escalation system')
                    const body = stripEscalationNotesPrefix(item.notes)
                    return (
                        <TimelineItem
                            key={item.id ?? `${item.actionId}-${item.createdOn}`}
                            $kind={kind}
                        >
                            <TlTitle>
                                {getEscalationHistoryTitle(item, kind)}
                            </TlTitle>
                            <TlMeta>
                                {when}
                                {actor ? ` · by ${actor}` : ''}
                            </TlMeta>
                            {body && <TlBody>{body}</TlBody>}
                        </TimelineItem>
                    )
                })}
            </Timeline>
            {createdOnly && (
                <div
                    style={{
                        color: '#64748b',
                        fontSize: 12,
                        lineHeight: 1.45,
                        marginTop: 10,
                        paddingTop: 10,
                        borderTop: '1px solid #e5e7eb',
                    }}
                >
                    {hasEscalationPolicy
                        ? 'Comments, reassign, and acknowledge appear under History. Reminder / escalated / overdue rows show here after the SLA sweep runs.'
                        : 'No Escalation policy on this ticket’s rule yet — only “Ticket created” can appear here until a policy is linked.'}
                </div>
            )}
        </>
    )
}
